import ProfileStats from "./ProfileStats";
export default ProfileStats;
